import React from "react";
import MainForm from "./containers/MainForm";

const Body = () => (
    <MainForm />
);

export default Body;


// WEBPACK FOOTER //
// ./src/components/Body.js